import state from "../../../store/state";

export default {
//   user: {},
//   token: null,
	domains: [],
  	messages: state.messages,
}



// WEBPACK FOOTER //
// ./src/app/company/vuex/state.js